export const appsConfigResultMock = [
  {
    appId: 'web3dtool',
    url: 'http://localhost:5000',
  },
];
